import { StatusCodes } from 'http-status-codes';
import React, { useState } from 'react';
import SecondaryButton from '~/src/components/common/forms/Button/SecondaryButton';
import FnbApi from '~/src/services/api/FnbApi';

interface Prop {
  onUpdate: () => void;
}

export default function ConsolidateFnbOrders({ onUpdate }: Prop): JSX.Element {
  const [updateFnbOrdersLoading, setUpdateFnbOrdersLoading] = useState<undefined | boolean>();
  const [updateFnbOrdersResult, setUpdateFnbOrdersResult] = useState<undefined | string>();
  const pullNewFnbOrders = async (): Promise<void> => {
    // setUpdateFnbOrdersResult(undefined);
    setUpdateFnbOrdersLoading(true);
    const res = await FnbApi.consolidate();
    if (res.status === StatusCodes.OK) {
      setUpdateFnbOrdersResult('Successfully consolidated Fnb Orders');

      onUpdate();
    } else {
      setUpdateFnbOrdersResult('Error consolidateing Fnb Orders');
    }
    setUpdateFnbOrdersLoading(false);
  };

  return (
    <>
      <SecondaryButton
        isBig
        title="Consolidate"
        onClick={pullNewFnbOrders}
        isSubmitting={updateFnbOrdersLoading}
      />

      {updateFnbOrdersResult && <div>{updateFnbOrdersResult}</div>}
    </>
  );
}
